var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal-pop", {
    attrs: {
      opened: _vm.popupShow,
      "no-negative-button": true,
      confirm: "MCOM-0000054",
      cancel: "MCOM-0000055"
    },
    on: {
      "update:opened": function($event) {
        _vm.popupShow = $event
      },
      confirm: _vm.extendLogin,
      cancel: _vm.logout
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _c("div", [
              _c("strong", { staticClass: "text-info" }, [
                _vm._v(
                  _vm._s(/*자동 로그아웃 남은시간*/ _vm.$t("MCOM-0000007"))
                )
              ]),
              _c("p", { staticClass: "log-timer" }, [
                _vm._v("00:" + _vm._s(_vm._.padStart(_vm.limit, 2, "0")))
              ]),
              _c("p", [
                _vm._v(
                  "- " +
                    _vm._s(
                      /*고객님의 안전한 금융거래 보호를 위해 로그인 후 약 10분 동안 이용이 없어 자동로그아웃됩니다.*/ _vm.$t(
                        "MCOM-0000008"
                      )
                    )
                )
              ]),
              _c("p", [
                _vm._v(
                  "- " +
                    _vm._s(
                      /*로그인 시간을 연장하시려면 로그인 연장하기 버튼을 클릭하여 주십시오. */ _vm.$t(
                        "MCOM-0000009"
                      )
                    )
                )
              ])
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }